import { DEFAULT_FIVERR_LOCALE, SUPPORTED_FIVERR_LOCALES_KEYS } from '@fiverr-private/localization';
import pathfinder from '@fiverr-private/pathfinder';

const priorities = {
    dropshipping_agent: {
        key: 'logged_out_homepage.de.top_priorities.priorities.dropshipping_agent',
        link: pathfinder('gig', { id: 'dropshipping-agent' }),
    },
    fortnite_training: {
        key: 'logged_out_homepage.de.top_priorities.priorities.fortnite_training',
        link: pathfinder('category', { id: 'lifestyle/buy/game-coaching/fortnite' }),
    },
    online_services: {
        key: 'logged_out_homepage.de.top_priorities.priorities.online_services',
        link: pathfinder('gig', { id: 'online-business' }),
    },
    discord_moderator: {
        key: 'logged_out_homepage.de.top_priorities.priorities.discord_moderator',
        link: pathfinder('gig', { id: 'discord-moderator' }),
    },
    buy_twitch_overlay: {
        key: 'logged_out_homepage.de.top_priorities.priorities.buy_twitch_overlay',
        link: pathfinder('category', { id: 'graphics-design/buy/graphics-for-streamers/twitch-overlays-screen-packs' }),
    },
    league_of_legends_training: {
        key: 'logged_out_homepage.de.top_priorities.priorities.league_of_legends_training',
        link: pathfinder('category', { id: 'lifestyle/buy/game-coaching/league-of-legends' }),
    },
    fivem_mlo: {
        key: 'logged_out_homepage.de.top_priorities.priorities.fivem_mlo',
        link: pathfinder('gig', { id: 'fivem-mlo' }),
    },
    valorant_training: {
        key: 'logged_out_homepage.de.top_priorities.priorities.valorant_training',
        link: pathfinder('category', { id: 'lifestyle/buy/game-coaching/valorant' }),
    },
    vtuber_model: {
        key: 'logged_out_homepage.de.top_priorities.priorities.vtuber_model',
        link: pathfinder('gig', { id: 'vtuber' }),
    },
    spotify_promotion: {
        key: 'logged_out_homepage.de.top_priorities.priorities.spotify_promotion',
        link: pathfinder('category', { id: 'online-marketing/buy/music-promotion/spotify' }),
    },
    discord_server: {
        key: 'logged_out_homepage.de.top_priorities.priorities.discord_server',
        link: pathfinder('gig', { id: 'discord-server' }),
    },
    sneaker_bot: {
        key: 'logged_out_homepage.de.top_priorities.priorities.sneaker_bot',
        link: pathfinder('gig', { id: 'sneaker-bot' }),
    },
    it_freelancer_jobs: {
        key: 'logged_out_homepage.de.top_priorities.priorities.it_freelancer_jobs',
        link: '/sellers/freelance-jobs/it',
    },
    vrchat_avatar: {
        key: 'logged_out_homepage.de.top_priorities.priorities.vrchat_avatar',
        link: pathfinder('gig', { id: 'vrchat-avatar' }),
    },
    create_twitch_logo: {
        key: 'logged_out_homepage.de.top_priorities.priorities.create_twitch_logo',
        link: pathfinder('gig', { id: 'twitch-logo' }),
    },
    steam_artwork: {
        key: 'logged_out_homepage.de.top_priorities.priorities.steam_artwork',
        link: pathfinder('gig', { id: 'steam' }),
    },
    logo_design: {
        key: 'logged_out_homepage.de.top_priorities.priorities.logo_design',
        link: pathfinder('category', { id: 'graphics-design/buy/creative-logo-design/3d' }),
    },
    facebook_advertising_consulting: {
        key: 'logged_out_homepage.de.top_priorities.priorities.facebook_advertising_consulting',
        link: pathfinder('category', { id: 'online-marketing/buy/social-marketing/facebook' }),
    },
    pixel_art_images: {
        key: 'logged_out_homepage.de.top_priorities.priorities.pixel_art_images',
        link: pathfinder('category', { id: 'graphics-design/buy/digital-illustration/pixel-art' }),
    },
    social_media_marketing_services: {
        key: 'logged_out_homepage.de.top_priorities.priorities.social_media_marketing_services',
        link: pathfinder('category', { id: 'online-marketing/social-marketing/social-media-management' }),
    },
    signature_logo_design: {
        key: 'logged_out_homepage.de.top_priorities.priorities.signature_logo_design',
        link: pathfinder('category', { id: 'graphics-design/buy/creative-logo-design/signature' }),
    },
    ghostwriter_book: {
        key: 'logged_out_homepage.de.top_priorities.priorities.ghostwriter_book',
        link: pathfinder('category', { id: 'writing-translation/book-and-ebook-writing/ghostwriting' }),
    },
    tiktok_advertising: {
        key: 'logged_out_homepage.de.top_priorities.priorities.tiktok_advertising',
        link: pathfinder('category', { id: 'online-marketing/buy/social-media-advertising/tiktok' }),
    },
    design_book_cover: {
        key: 'logged_out_homepage.de.top_priorities.priorities.design_book_cover',
        link: pathfinder('category', { id: 'graphics-design/book-design/cover' }),
    },
    electrical_circuit_diagram: {
        key: 'logged_out_homepage.de.top_priorities.priorities.electrical_&_circuit_diagram',
        link: pathfinder('category', { id: 'programming-tech/electronics-engineering/pcb' }),
    },
    proofreading_german: {
        key: 'logged_out_homepage.de.top_priorities.priorities.proofreading_german',
        link: pathfinder('category', { id: 'writing-translation/buy/proofreading-editing/german' }),
    },
    create_discord_bot: {
        key: 'logged_out_homepage.de.top_priorities.priorities.create_discord_bot',
        link: pathfinder('category', { id: 'programming-tech/buy/chatbots/discord' }),
    },
    youtube_manager: {
        key: 'logged_out_homepage.de.top_priorities.priorities.youtube_manager',
        link: pathfinder('category', { id: 'online-marketing/online-video-marketing/youtube-channel-management' }),
    },
    ghost_producer: {
        key: 'logged_out_homepage.de.top_priorities.priorities.ghost_producer',
        link: pathfinder('category', { id: 'music-audio/producers-composers/ghost-production' }),
    },
    music_visualization: {
        key: 'logged_out_homepage.de.top_priorities.priorities.music_visualization',
        link: pathfinder('category', { id: 'video-animation/music-videos/music-visualization' }),
    },
    virtual_assistant: {
        key: 'logged_out_homepage.de.top_priorities.priorities.virtual_assistant',
        link: pathfinder('skill_page', { skill: 'virtual-assistance' }),
    },
    bookkeeper: {
        key: 'logged_out_homepage.de.top_priorities.priorities.bookkeeper',
        link: pathfinder('skill_page', { skill: 'bookkeeping' }),
    },
    interior_designer: {
        key: 'logged_out_homepage.de.top_priorities.priorities.interior_designer',
        link: pathfinder('skill_page_cat_architecture_engineering'),
    },
    accountant: {
        key: 'logged_out_homepage.de.top_priorities.priorities.accountant',
        link: pathfinder('skill_page', { skill: 'accounting' }),
    },
    project_manager: {
        key: 'logged_out_homepage.de.top_priorities.priorities.project_manager',
        link: pathfinder('skill_page', { skill: 'project-management' }),
    },
    tax_accountant: {
        key: 'logged_out_homepage.de.top_priorities.priorities.tax_accountant',
        link: pathfinder('skill_page', { skill: 'tax-accounting' }),
    },
    salesforce_expert: {
        key: 'logged_out_homepage.de.top_priorities.priorities.salesforce_expert',
        link: pathfinder('skill_page', { skill: 'salesforce' }),
    },
    lawyer: {
        key: 'logged_out_homepage.de.top_priorities.priorities.lawyer',
        link: pathfinder('skill_page', { skill: 'law' }),
    },
    business_operations: {
        key: 'logged_out_homepage.de.top_priorities.priorities.business_operations',
        link: pathfinder('skill_page_cat_business_operations'),
    },
    brand_strategist: {
        key: 'logged_out_homepage.de.top_priorities.priorities.brand_strategist',
        link: pathfinder('skill_page', { skill: 'brand-strategy' }),
    },
    product_manager: {
        key: 'logged_out_homepage.de.top_priorities.priorities.product_manager',
        link: pathfinder('skill_page', { skill: 'product-management' }),
    },
    video_editor: {
        key: 'logged_out_homepage.de.top_priorities.priorities.video_editor',
        link: pathfinder('skill_page', { skill: 'video-editing' }),
    },
    logo_designer: {
        key: 'logged_out_homepage.de.top_priorities.priorities.logo_designer',
        link: pathfinder('skill_page', { skill: 'logo-design' }),
    },
    graphic_designer: {
        key: 'logged_out_homepage.de.top_priorities.priorities.graphic_designer',
        link: pathfinder('skill_page_cat_creative'),
    },
    fashion_designer: {
        key: 'logged_out_homepage.de.top_priorities.priorities.fashion_designer',
        link: pathfinder('skill_page', { skill: 'fashion-design' }),
    },
    animator: {
        key: 'logged_out_homepage.de.top_priorities.priorities.animator',
        link: pathfinder('skill_page', { skill: 'animation' }),
    },
    adobe_photoshop_expert: {
        key: 'logged_out_homepage.de.top_priorities.priorities.adobe_photoshop_expert',
        link: pathfinder('skill_page', { skill: 'adobe-photoshop' }),
    },
    illustrator: {
        key: 'logged_out_homepage.de.top_priorities.priorities.illustrator',
        link: pathfinder('skill_page', { skill: 'illustration' }),
    },
    seo_expert: {
        key: 'logged_out_homepage.de.top_priorities.priorities.seo_expert',
        link: pathfinder('skill_page_cat_marketing_sales'),
    },
    web_developer: {
        key: 'logged_out_homepage.de.top_priorities.priorities.web_developer',
        link: pathfinder('skill_page_cat_technical'),
    },
    product_photographer: {
        key: 'logged_out_homepage.de.top_priorities.priorities.product_photographer',
        link: pathfinder('skill_page', { skill: 'product-photography' }),
    },
    book_cover_designer: {
        key: 'logged_out_homepage.de.top_priorities.priorities.book_cover_designer',
        link: pathfinder('skill_page', { skill: 'book-cover-design' }),
    },
    voice_over_artist: {
        key: 'logged_out_homepage.de.top_priorities.priorities.voice_over_artist',
        link: pathfinder('skill_page', { skill: 'voice-over' }),
    },
    tattoo_designer: {
        key: 'logged_out_homepage.de.top_priorities.priorities.tattoo_designer',
        link: pathfinder('skill_page', { skill: 'tattoo-design' }),
    },
    content_writer: {
        key: 'logged_out_homepage.de.top_priorities.priorities.content_writer',
        link: pathfinder('skill_page_cat_writing'),
    },
    social_media_manager: {
        key: 'logged_out_homepage.de.top_priorities.priorities.social_media_manager',
        link: pathfinder('skill_page', { skill: 'social-media-management' }),
    },
    digital_marketer: {
        key: 'logged_out_homepage.de.top_priorities.priorities.digital_marketer',
        link: pathfinder('skill_page', { skill: 'digital-marketing' }),
    },
    facebook_ads_expert: {
        key: 'logged_out_homepage.de.top_priorities.priorities.facebook_ads_expert',
        link: pathfinder('skill_page', { skill: 'facebook-ads' }),
    },
};

const prioritiesForLocalizedPages = [
    priorities.virtual_assistant,
    priorities.bookkeeper,
    priorities.interior_designer,
    priorities.accountant,
    priorities.project_manager,
    priorities.tax_accountant,
    priorities.salesforce_expert,
    priorities.lawyer,
    priorities.business_operations,
    priorities.brand_strategist,
    priorities.product_manager,
    priorities.video_editor,
    priorities.logo_designer,
    priorities.graphic_designer,
    priorities.fashion_designer,
    priorities.animator,
    priorities.adobe_photoshop_expert,
    priorities.illustrator,
    priorities.seo_expert,
    priorities.web_developer,
    priorities.product_photographer,
    priorities.book_cover_designer,
    priorities.voice_over_artist,
    priorities.tattoo_designer,
    priorities.content_writer,
    priorities.social_media_manager,
    priorities.digital_marketer,
    priorities.facebook_ads_expert,
];

export const prioritiesMapByLocale = {
    [DEFAULT_FIVERR_LOCALE]: [
        priorities.dropshipping_agent,
        priorities.fortnite_training,
        priorities.online_services,
        priorities.discord_moderator,
        priorities.buy_twitch_overlay,
        priorities.league_of_legends_training,
        priorities.fivem_mlo,
        priorities.valorant_training,
        priorities.vtuber_model,
        priorities.spotify_promotion,
        priorities.discord_server,
        priorities.sneaker_bot,
        priorities.it_freelancer_jobs,
        priorities.vrchat_avatar,
        priorities.create_twitch_logo,
        priorities.steam_artwork,
        priorities.logo_design,
        priorities.facebook_advertising_consulting,
        priorities.pixel_art_images,
        priorities.social_media_marketing_services,
        priorities.signature_logo_design,
        priorities.ghostwriter_book,
        priorities.tiktok_advertising,
        priorities.design_book_cover,
        priorities.electrical_circuit_diagram,
        priorities.proofreading_german,
        priorities.create_discord_bot,
        priorities.youtube_manager,
        priorities.ghost_producer,
        priorities.music_visualization,
    ],
    [SUPPORTED_FIVERR_LOCALES_KEYS.DE_DE]: prioritiesForLocalizedPages,
    [SUPPORTED_FIVERR_LOCALES_KEYS.ES]: prioritiesForLocalizedPages,
    [SUPPORTED_FIVERR_LOCALES_KEYS.FR_FR]: prioritiesForLocalizedPages,
    [SUPPORTED_FIVERR_LOCALES_KEYS.PT_BR]: prioritiesForLocalizedPages,
    [SUPPORTED_FIVERR_LOCALES_KEYS.IT_IT]: prioritiesForLocalizedPages,
    [SUPPORTED_FIVERR_LOCALES_KEYS.NL_NL]: prioritiesForLocalizedPages,
};

export const TOP_PRIORITIES_TAG_TEST_ID = 'top-priorities-tag';
export const TOP_PRIORITIES_TITLE_TEST_ID = 'top-priorities-title';
